import { Outlet, useLocation } from "react-router-dom";
import PageContainer from "../../../components/common/PageContainer";

const EJOAndESRApprovalPage = () => {
  const location = useLocation();

  const route = location.pathname.split("/");

  const subTitle =
    route[1] == "esr-management" ? "JO Management" : "MRRF/JO Approval";

  const subModuleTitle =
    (route[2] == `ejo-pending` && `MRRF Pending Approval`) ||
    (route[2] == `ejo-approved-and-esr-uncreated` &&
      `MRRF Approved > JO Uncreated`) ||
    (route[2] == `esr-pending-approval` && `JO Pending Approval`) ||
    (route[2] == `esr-approved-and-unstarted` && `JO Approved > Unstarted`) ||
    (route[2] == `esr-wip` && `JO WIP`) ||
    (route[2] === `esr-completed` && `JO Completed`);

  return (
    <>
      <PageContainer
        title="My Dashboard + Tasks"
        subTitle={`${subTitle}`}
        submoduleTitle={`${subModuleTitle}`}
        showDate
      >
        <Outlet />
      </PageContainer>
    </>
  );
};

export default EJOAndESRApprovalPage;
